import { UpdateForm } from '../../../../components'
import { AlertProvider } from '../../../../contexts'
import { GET_EMPLOYMENTS, SAVE_EMPLOYMENTS_DATA } from '../../../../graphql'
import { useDataRefresh, useStateWrapper } from '../../../../hooks'
import { EmploymentsQueryType } from '../../../../types/types'
import { EmploymentsSubmitButton, EmploymentsTable } from './components'
import {
  useEmploymentData,
  useEmploymentFormData,
  useEmploymentKeysAndColumns
} from './hooks'

export const EmploymentInfo = () => {
  const { StateRenderWrapper, data, execute } =
    useStateWrapper<EmploymentsQueryType>({
      query: GET_EMPLOYMENTS
    })

  const setShouldRefresh = useDataRefresh(execute)

  const { employmentArray, newEmploymentRow } = useEmploymentData(
    data?.employments?.tyosuhteet
  )

  const { createVariables, initialValues, validationSchema } =
    useEmploymentFormData(employmentArray)

  const employmentKeysAndColumns = useEmploymentKeysAndColumns()

  return (
    <AlertProvider>
      <StateRenderWrapper>
        <UpdateForm
          query={SAVE_EMPLOYMENTS_DATA}
          createVariablesFn={createVariables}
          formikProps={{
            initialValues,
            validationSchema,
            validateOnChange: false
          }}
          submitCheckerProps={{
            errorMessageId: 'common.save.error',
            successFn: () => setShouldRefresh(true),
            successMessageId: 'pages.ownInfoPage.employment.save.success'
          }}
        >
          <EmploymentsTable
            {...{ employmentArray, newEmploymentRow }}
            cellProps={employmentKeysAndColumns}
          />
          {/* TODO: lisätään ammatit ja velvoitteet, kun ne ovat valmiit,
           mistä professionin ja fieldin arvot???? */}
          {/*  <ProfessionInfo
            profession={null}
            professionTitle={data?.employments?.ammattiNimike}
            field={null}
          /> 
          <ObligationsTable obligations={data?.employmentObligations} />
          */}
          <EmploymentsSubmitButton
            employmentKeysAndColumns={employmentKeysAndColumns}
          />
        </UpdateForm>
      </StateRenderWrapper>
    </AlertProvider>
  )
}
